import $ from 'jquery';
import SectionBaseClass from '../base/SectionBaseClass';
import Util from '../util/Util';


/**
 * 遅延ロード
 *
 * example->{@link SvgDelayLoadManagerClass}
 * @param {jQueryObject} _target
 * @param {Boolean} _isAnim
 */
export default class SvgDelayLoadClass extends SectionBaseClass {
  constructor(_target, _isAnim) {
    super(_target);
    this.name = 'SvgDelayLoadClass';
    this.spSize = Util.BREAK_POINT;
    this.isAnim = _isAnim;
    this.windowSize;
    this.CL_LOADEND = 'isLoadEnd';
    this.tweenObj;
  }

  onCreate() {
    super.onCreate();
  }

  onStop() {
    super.onStop();

    if (this.tweenObj && this.tweenObj.isActive()) {
      this.tweenObj.pause();
    }
    this.tweenObj = null;
  }

  onRemove() {
    this.target.removeClass(this.CL_LOADEND);
    this.target.empty();
    super.onRemove();
  }

  onActive() {
    super.onActive();
    this.onChangeBreakPoint();
  }

  onResize(size) {
    this.windowSize = size;
    if (!this.target) { return; }

    let wh = size.h;
    let parentTarget = this.target.parent();
    let offset = $.extend({}, parentTarget.offset());
    let top = Math.floor(offset.top);
    let bottom = Math.floor(top + parentTarget.outerHeight(true));
    this.offset = { top: top - wh, bottom: bottom + size.h };

    this.htmlLast = $('html').outerHeight(true) - size.h - 10;
  }

  onChangeBreakPoint(_b) {
    if (!this.isActive) { return; }

    let self = this;
    let windowWidth = self.windowSize.w;

    let _this = self.target;
    _this.removeClass(self.CL_LOADEND);
    let src = _this.attr('data-src');
    let cl = _this.attr('class');
    if (!src) { return true; }
    let cSrc = null;
    if (!cl) { cl = ''; }
    if (cl.indexOf('both') !== -1) {
      cSrc = src;
    } else if (windowWidth <= self.spSize && cl.indexOf('onlyPc') === -1) {
      let spsrc = _this.attr('data-src_sp');
      cSrc = (spsrc) ? spsrc : Util.getSpImagePath(src);
    } else if (windowWidth > self.spSize && cl.indexOf('onlySp') === -1) {
      cSrc = src;
    }

    if (!cSrc) { return true; }

    self.target.load(cSrc, () => {
      if (!self.isLoad) { return; }
      self.onComplete();
    });
  }

  onComplete() {
    let self = this;
    self.target.addClass(self.CL_LOADEND);
  }

}
